import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@services';
import { ToastrService } from 'ngx-toastr';
import { SharedModule } from '../../shared/shared.module';

@Component({
  selector: 'app-terms-and-condition',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './terms-and-condition.component.html',
})
export class TermsAndConditionComponent {
  constructor(
    private authService: AuthenticationService,
    private _toast: ToastrService,
    private route: ActivatedRoute,
  ) {}
  content!: string;
  contentName: string = '';
  ngOnInit() {
    const policyType = this.route.snapshot.paramMap.get('content-type')?.toLowerCase();
    if (policyType === 'terms-and-conditions') {
      this.contentName = 't&c';
    } else if (policyType === 'privacy-policy') {
      this.contentName = 'Privacy Policy';
    }
    if (this.contentName) {
      this.getPolicyContent(this.contentName);
    }
  }

  getPolicyContent(type: string) {
    this.authService.getPolicyContent(type).subscribe({
      next: (res) => {
        if (res.status) {
          const [data] = res.data;
          this.content = data?.details?.fullText?.hebrew;
        } else {
          this._toast.error(res.message);
        }
      },
      error: (err) => {
        this._toast.error(err.message);
      },
    });
  }
}
